if (typeof AnnouncementBar !== 'function') {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this.slider = this.querySelector('.announcement-bar__slider') || this.querySelector('[data-js-slider]');
      this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
      this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

      this.autoplayDelay = 2500;
      this.autoplayInterval = null;
      this.isAnimating = false;

      if (!this.slider) return;

      this.setupInfiniteSlider();

      if (this.slides.length <= 3) return;

      if (this.nextButton) {
        this.nextButton.classList.remove('announcement-bar__content-nav--disabled');

        this.nextButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.changeSlide('next');
        });
      }

      if (this.prevButton) {
        this.prevButton.classList.remove('announcement-bar__content-nav--disabled');

        this.prevButton.addEventListener('click', () => {
          this.stopAutoplay();
          this.changeSlide('prev');
        });
      }

      this.startAutoplay();
    }

    setupInfiniteSlider() {
      this.slider.querySelectorAll('[data-announcement-clone]').forEach(clone => clone.remove());

      this.realSlides = Array.from(this.slider.querySelectorAll('.announcement'));

      if (this.realSlides.length <= 1) return;

      const firstClone = this.realSlides[0].cloneNode(true);
      const lastClone = this.realSlides[this.realSlides.length - 1].cloneNode(true);

      firstClone.setAttribute('data-announcement-clone', 'first');
      lastClone.setAttribute('data-announcement-clone', 'last');

      this.slider.insertBefore(lastClone, this.realSlides[0]);
      this.slider.appendChild(firstClone);

      this.slides = Array.from(this.slider.querySelectorAll('.announcement'));

      this.index = 1;

      requestAnimationFrame(() => {
        this.jumpToSlide(this.index);
      });
    }

    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.changeSlide('next');
      }, this.autoplayDelay);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    changeSlide(direction) {
      if (this.isAnimating) return;

      this.isAnimating = true;

      if (direction === 'next') {
        this.index++;
      }

      if (direction === 'prev') {
        this.index--;
      }

      this.slider.scrollTo({
        top: 0,
        left: this.slides[this.index].offsetLeft,
        behavior: 'smooth'
      });

      this.waitForScrollEnd(() => {
        this.handleInfiniteLoop();
        this.isAnimating = false;
      });
    }

    waitForScrollEnd(callback) {
      let finished = false;

      const finish = () => {
        if (finished) return;

        finished = true;
        this.slider.removeEventListener('scrollend', finish);
        clearTimeout(fallback);
        callback();
      };

      this.slider.addEventListener('scrollend', finish, { once: true });

      const fallback = setTimeout(finish, 700);
    }

    handleInfiniteLoop() {
      const currentSlide = this.slides[this.index];

      if (!currentSlide) return;

      if (currentSlide.dataset.announcementClone === 'first') {
        this.index = 1;
        this.jumpToSlide(this.index);
      }

      if (currentSlide.dataset.announcementClone === 'last') {
        this.index = this.slides.length - 2;
        this.jumpToSlide(this.index);
      }
    }

    jumpToSlide(index) {
      const previousScrollBehavior = this.slider.style.scrollBehavior;

      this.slider.style.scrollBehavior = 'auto';
      this.slider.scrollLeft = this.slides[index].offsetLeft;

      requestAnimationFrame(() => {
        this.slider.style.scrollBehavior = previousScrollBehavior;
      });
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

  }

  if (typeof customElements.get('announcement-bar') === 'undefined') {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}